import PageHeader from "../components/PageHeader";
import { CERTIFICATIONS } from "../data/site";
import { ShieldCheck, FileCheck2, Award, HardHat } from "lucide-react";

const ICONS = [Award, FileCheck2, ShieldCheck, HardHat];

export default function Certificazioni() {
  return (
    <>
      <PageHeader
        eyebrow="Certificazioni"
        title="Qualificati per ogni tipo di appalto."
        description="L'impresa Fratelli D'Ambrosio possiede le certificazioni SOA e ISO 9001:2008 che consentono la partecipazione a gare di appalto degli enti pubblici."
      />

      <section data-reveal className="py-16 md:py-24 bg-white border-b border-neutral-200">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {CERTIFICATIONS.map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                data-testid={`cert-card-${i}`}
                className="bg-white p-10 md:p-14 rounded-2xl border border-neutral-200 group hover:bg-[#0B1E3F] hover:text-white transition-colors"
              >
                <div className="flex items-start justify-between mb-12">
                  <div className="w-14 h-14 border border-[#1D4ED8] text-[#1D4ED8] group-hover:bg-[#1D4ED8] group-hover:text-white flex items-center justify-center transition-colors rounded-xl">
                    <Icon className="w-6 h-6" />
                  </div>
                  <div className="font-mono text-xs tracking-[0.25em] uppercase text-neutral-400">
                    / 0{i + 1}
                  </div>
                </div>
                <div className="font-display font-black uppercase tracking-tight text-3xl sm:text-4xl md:text-5xl mb-4 break-words">
                  {c.code}
                </div>
                <div className="font-display font-semibold text-xl mb-4">{c.title}</div>
                <p className="text-neutral-600 group-hover:text-neutral-400 leading-relaxed max-w-md">
                  {c.description}
                </p>
              </div>
            );
          })}
        </div>
      </section>

      <section data-reveal className="py-20 md:py-28 bg-[#F5F5F3]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="overline mb-6">/ Garanzie</div>
            <h2 className="hero-title text-4xl md:text-5xl lg:text-6xl">
              Serietà<br />documentata.
            </h2>
          </div>
          <div className="md:col-span-7 md:pt-8 space-y-6 text-lg text-neutral-700 leading-relaxed">
            <p>
              Tutte le nostre certificazioni sono mantenute attive e aggiornate secondo le normative
              vigenti. Siamo in grado di fornire, su richiesta, la documentazione completa per
              partecipare a gare di appalto pubbliche o per la valutazione preliminare da parte di
              committenti privati.
            </p>
            <p>
              Ogni cantiere viene gestito nel pieno rispetto del D.Lgs. 81/08 sulla sicurezza del
              lavoro, con personale formato, DPI adeguati e Piano Operativo di Sicurezza (POS) redatto
              per ogni singola commessa.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
